import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "web-reward-congratulations",
    templateUrl: "./reward-congratulations.component.html",
    styleUrls: ["./reward-congratulations.component.scss"],
})
export class RewardCongratulationsComponent {
    constructor(private dialogRef: MatDialogRef<RewardCongratulationsComponent>) {}

    submit() {
        this.dialogRef.close({ data: true });
    }

    closeDialog() {
        this.dialogRef.close({ data: true });
    }
}
